import { Breadcrumb } from '../../data'
import { BaseModel } from '../base-model'
import { WorklistAutomation } from './automation'
import { WorklistField } from './field'
import { WorklistFilter } from './filter'
import { WorklistWeightRule } from './weight-rule'
import { WorklistData } from './worklist.data'

export interface WorklistSettings {
  requireNotes?: boolean
  distinctPatients?: boolean
  escalation?: boolean
  escalationWorkLists?: string[]
  advancedAssignment?: boolean
  assignmentGroupingFields?: string[]
  revalidate?: { quantity: number, units: string }
  snooze?: { options: string[], required: boolean }
}

export class WorklistModel extends BaseModel implements Breadcrumb {
  name: string
  description: string
  referenceType: Worklist.REFERENCE_TYPE
  /**
   * Current number of items in the worklist
   */
  count: number
  filters?: WorklistFilter[]
  exclusionWorkLists?: string[]
  fields: WorklistField[]
  weightRules: WorklistWeightRule[]
  automations?: WorklistAutomation[]
  roles?: string[]
  users?: string[]
  settings?: WorklistSettings
  lastProcessedAt?: moment.Moment
  distributionByDay?: Record<string, number>

  constructor(data?: WorklistData) {
    super(data, true)

    this.name = data?.name || ''
    this.description = data?.description || ''
    this.referenceType = data?.referenceType || 'patient'
    this.count = data?.count || 0
    this.filters = data?.filters
    this.exclusionWorkLists = data?.exclusionWorkLists
    this.fields = data?.fields || []
    this.weightRules = data?.weightRules || []
    this.automations = data?.automations
    this.roles = data?.roles
    this.users = data?.users
    this.settings = data?.settings
    this.distributionByDay = data?.distributionByDay

    if (data?.lastProcessedAt) {
      this.lastProcessedAt = this.transformDate(data.lastProcessedAt, false)
    }
  }

  get text(): string {
    return this.name
  }

  get url(): string {
    return `/worklist/${this.id}`
  }

  get editUrl(): string {
    return `/worklist/${this.id}/edit`
  }

  override toJSON() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      referenceType: this.referenceType,
      filters: this.filters,
      exclusionWorkLists: this.exclusionWorkLists,
      fields: this.fields,
      weightRules: this.weightRules,
      automations: this.automations,
      roles: this.roles,
      users: this.users,
      settings: this.settings,
    }
  }
}

export namespace Worklist {
  export type REFERENCE_TYPE = 'patient' | 'appointment' | 'arbitrary' | 'file'
}
